import React from "react";

import { Box, Drawer, Button } from "@mui/material";
import { NavLink } from "react-router-dom";

import {
  Menu,
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Person,
  Favorite,
  ShoppingCart,
  ContactPhone,
  LiveHelp,
  VerifiedUser,
  Logout,
  LocalLibrary,
  Share,
  Info,
  ShoppingBag,
  Dashboard,
} from "@mui/icons-material";
import { Logo } from "asset";
import { useAppContext } from "contexts";

const RightNav = () => {
  const [state, setState] = React.useState(false);
  const { user } = useAppContext();

  const navigation = [
    {
      name: "Profile",
      path: "/profile",
      icon: <Person />,
    },

    {
      name: "My Orders",
      path: "/profile/myorder",
      icon: <ShoppingBag />,
    },
    {
      name: "Cart",
      path: "/cart",
      icon: <ShoppingCart />,
    },
    {
      name: "Wishlist",
      path: "/profile/wishlist",
      icon: <Favorite />,
    },
    {
      name: "Contact Us",
      path: "/contact",
      icon: <ContactPhone />,
    },

    {
      name: "About Us",
      path: "/about",
      icon: <Info />,
    },
    {
      name: "Refer And Earn",
      path: "/profile/refer",
      icon: <Share />,
    },
    {
      name: "Privacy Policy",
      path: "/privacypolicy",
      icon: <VerifiedUser />,
    },

    {
      name: "Terms & Conditions",
      path: "/terms",
      icon: <LocalLibrary />,
    },
    {
      name: "FAQ",
      path: "/faq",
      icon: <LiveHelp />,
    },
    {
      name: "Log out",
      path: "/login",
      icon: <Logout />,
    },
  ];

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      className=" responsive-navbar-right-nav-list"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {/* <div className="responsive-nav-logo">
        <img src={Logo} alt="" />
      </div> */}

      <div className="responsive-nav-navigation flex-column w-100">
        <div className="responsive-nav-logo flex-row align-items-center">
          <img src={Logo} alt="" />
        </div>
        <ul className="responsive-nav-navigation-ul flex-column ">
          {user?.role === "super-admin" && (
            <li className="flex-row align-items-center gap-2">
              <span className="flex-row align-items-center justify-content-center mob-nav-icon">
                <Dashboard />
              </span>

              <NavLink
                to={"/admin/dashboard"}
                onClick={toggleDrawer(anchor, false)}
              >
                Dashboard
              </NavLink>
            </li>
          )}
          {navigation.map((item, index) => {
            return (
              <li key={index} className="flex-row align-items-center gap-2">
                {item.icon && (
                  <span className="flex-row align-items-center justify-content-center mob-nav-icon">
                    {item.icon}
                  </span>
                )}

                <NavLink to={item.path} onClick={toggleDrawer(anchor, false)}>
                  {item.name}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="responsive-navbar-social w-100">
        <ul className="responsive-navbar-social-ul flex-row">
          <li>
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="social-facebook"
            >
              <Facebook />
            </a>
          </li>
          <li>
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="social-twitter"
            >
              <Twitter />
            </a>
          </li>
          <li>
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="social-linkedin"
            >
              <LinkedIn />
            </a>
          </li>
          <li>
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="social-instagram"
            >
              <Instagram />
            </a>
          </li>
        </ul>
      </div>
      {/* <div
        onClick={toggleDrawer(anchor, false)}
        className="responsive-nav-close-now flex-row align-items-center justify-content-center "
      >
        Close
      </div> */}
    </Box>
  );

  // console.log(state);

  return (
    <>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, !state.right)}>
            <Menu className="hamburger-menu" />
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </>
  );
};

export default RightNav;
